export const PopupProp = Object.freeze({
    ShowOn: 'showOn',
    ContentType: 'contentType',
    TableProps: 'tableProps',
    TextProps: 'textProps',
});